module.exports = __webpack_public_path__ + "static/media/pinterest.99a6326e.svg";